import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n/config";
import { mockServerController } from "./lib/mock-control";

// Enable MSW mocking in development
async function enableMocking() {
  // Check for URL parameter trigger
  const urlParams = new URLSearchParams(window.location.search);
  const mockEnabled = urlParams.get('mock') === 'true';

  // Enable mocking if:
  // 1. In development mode, AND
  // 2. Either VITE_ENABLE_MOCK is true OR mock=true URL parameter is present
  const shouldEnableMocking = import.meta.env.DEV &&
    (import.meta.env.VITE_ENABLE_MOCK === 'true' || mockEnabled);

  if (shouldEnableMocking) {
    const { startMockServer } = await import('./mocks');

    await startMockServer();

    // Mark as started in the controller
    mockServerController.markAsStarted(mockEnabled ? 'url' : 'env');

    console.log(`🎭 Mock server started ${mockEnabled ? 'via URL parameter (?mock=true)' : 'via environment variable'}`);
    console.log('📋 Available test accounts:');
    console.log('  Publisher: publisher@test.com / Test@123');
    console.log('  Publisher 2: publisher2@test.com / Test@123');
    console.log('  Reviewer: reviewer@alc.com / Reviewer@123');
    console.log('  Admin: admin@arabookverse.com / Admin@123');

    // Show available console commands in development
    console.log('');
    console.log('🛠️ Console commands: window.mockServer.start(), .stop(), .status(), .endpoints()');
  }
}

enableMocking().then(() => {
  createRoot(document.getElementById("root")!).render(<App />);
});
